import React from 'react'
import './Page3.css'

export default function Page3() {
    return (
        <div>
            I'M PAGE 3
        </div>
    )
}
